import React, { FC } from "react";
import { List, Button, Popconfirm } from "antd";
import { Icons } from "../vpd-icons/icons";
import { NotificationRule } from "../../data-types";
import styles from "./notification-rules-list.css";

const {
  ["list-item"]: listItemClassName,
  ["top-row"]: topRowClassName,
  ["popconfirm-okay"]: popconfirmOkayClassName,
} = styles;

type Props = {
  notificationRules: NotificationRule[];
  onDeleteNotificationRule: (id: number) => void;
  onClickNotificationRule: (id: number) => void;
  onClickCreateNotificationButton: () => void;
};

export const NotificationRulesList: FC<Props> = ({
  notificationRules,
  onDeleteNotificationRule,
  onClickNotificationRule,
  onClickCreateNotificationButton,
}) => {
  return (
    <>
      <div className={topRowClassName}>
        <Button type="primary" onClick={onClickCreateNotificationButton}>
          Create Alert
        </Button>
      </div>
      <List
        dataSource={notificationRules}
        split={false}
        renderItem={(item) => (
          <List.Item
            key={item.id}
            className={listItemClassName}
            onClick={() => {
              onClickNotificationRule(item.id);
            }}
            extra={
              <Popconfirm
                okButtonProps={{ className: popconfirmOkayClassName }}
                placement="left"
                title="Are you sure you want to delete this notification?"
                onConfirm={(e) => {
                  if (e) {
                    e.stopPropagation();
                    onDeleteNotificationRule(item.id);
                  }
                }}
                onCancel={(e) => {
                  if (e) {
                    e.stopPropagation();
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  icon={Icons.Delete}
                  shape="circle"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  type="link"
                />
              </Popconfirm>
            }
          >
            {item.name}
          </List.Item>
        )}
      />
    </>
  );
};
